import {
  ApplicationConfig,
  PLATFORM_ID,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { provideRouter } from '@angular/router';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideTranslateService, provideTranslateLoader } from '@ngx-translate/core';

import { routes } from './app.routes';
import { GtmService } from './core/services/gtm.service';
import { traduccionesLoaderFactory } from './core/services/traducciones.loader';
import { environment } from '../environments/environment';

function inicializarApp(): void {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return;
  }
  const gtmId = environment.gtmId;
  if (!gtmId) {
    return;
  }
  const gtm = inject(GtmService);
  const win = window as unknown as {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
  };
  if (typeof win.requestIdleCallback === 'function') {
    win.requestIdleCallback(() => gtm.cargar(gtmId), { timeout: 2000 });
  } else {
    setTimeout(() => gtm.cargar(gtmId), 2000);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideHttpClient(),
    provideTranslateService({
      loader: provideTranslateLoader(traduccionesLoaderFactory),
      fallbackLang: 'es',
    }),
    provideAppInitializer(inicializarApp),
  ],
};
